module.exports = __webpack_public_path__ + "img/titlezh.60ee8233.png";